import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { KPICard } from '../../components/ui/KPICard';
import { Card } from '../../components/ui/Card';
import { DataTable } from '../../components/ui/DataTable';
import { Tabs } from '../../components/ui/Tabs';
import { Button } from '../../components/ui/Button';
import { StatusPill } from '../../components/ui/StatusPill';
import { Badge } from '../../components/ui/Badge';
import { Drawer } from '../../components/ui/Drawer';
import { Timeline } from '../../components/ui/Timeline';
import { AlertCircleIcon, CheckCircleIcon, ClockIcon, FileTextIcon } from 'lucide-react';
const incidents = [{
  id: 'QI-2026-003',
  title: 'Temperature deviation on SHP-2026-089',
  severity: 'Major',
  category: 'Logistics',
  reported: 'Mar 11, 2026',
  due: 'Mar 22, 2026',
  status: 'Open'
}, {
  id: 'QI-2025-018',
  title: 'Packaging damage batch PL-2025-445',
  severity: 'Minor',
  category: 'Packaging',
  reported: 'Jan 10, 2026',
  due: 'Jan 20, 2026',
  status: 'Closed'
}, {
  id: 'QI-2025-012',
  title: 'Short shelf life on salmon delivery',
  severity: 'Major',
  category: 'Product Quality',
  reported: 'Nov 15, 2025',
  due: 'Nov 25, 2025',
  status: 'Closed'
}, {
  id: 'QI-2025-008',
  title: 'Foreign object found in squid batch',
  severity: 'Critical',
  category: 'Food Safety',
  reported: 'Sep 01, 2025',
  due: 'Sep 05, 2025',
  status: 'Closed'
}];
export const QualityPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [selectedIncident, setSelectedIncident] = useState<any>(null);
  const getSeverityBadge = (severity: string) => {
    switch (severity) {
      case 'Critical':
        return <Badge variant="error" data-id="element-1607">{severity}</Badge>;
      case 'Major':
        return <Badge variant="warning" data-id="element-1608">{severity}</Badge>;
      case 'Minor':
        return <Badge variant="info" data-id="element-1609">{severity}</Badge>;
      default:
        return <Badge variant="neutral" data-id="element-1610">{severity}</Badge>;
    }
  };
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-1611">
      <PageHeader title="Quality & Incidents" breadcrumbs={[{
      label: 'Home',
      href: '/supplier/dashboard'
    }, {
      label: 'Quality'
    }]} primaryAction={<Button data-id="element-1613">Report Incident</Button>} data-id="element-1612" />
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-1614">
        <KPICard title="Open Incidents" value="1" icon={<AlertCircleIcon className="w-5 h-5 text-status-error" data-id="element-1616" />} data-id="element-1615" />
        <KPICard title="Pending Response" value="1" icon={<ClockIcon className="w-5 h-5 text-status-warning" data-id="element-1618" />} data-id="element-1617" />
        <KPICard title="Closed This Year" value="3" icon={<CheckCircleIcon className="w-5 h-5 text-status-success" data-id="element-1620" />} data-id="element-1619" />
        <KPICard title="Avg Resolution Days" value="12" icon={<ClockIcon className="w-5 h-5" data-id="element-1622" />} trend="down" trendValue="-2 days" data-id="element-1621" />
      </div>
      <Card noPadding data-id="element-1623">
        <div className="px-6 pt-4 border-b border-border-light" data-id="element-1624">
          <Tabs tabs={[{
          id: 'all',
          label: 'All Cases'
        }, {
          id: 'open',
          label: 'Open'
        }, {
          id: 'pending',
          label: 'Pending My Action'
        }, {
          id: 'closed',
          label: 'Closed'
        }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-1625" />
        </div>
        <div className="p-6" data-id="element-1626">
          <DataTable data={incidents} columns={[{
          header: 'Case ID',
          accessorKey: 'id',
          cell: row => <span className="font-medium text-fpg-navy" data-id="element-1628">{row.id}</span>
        }, {
          header: 'Title',
          accessorKey: 'title'
        }, {
          header: 'Severity',
          cell: row => getSeverityBadge(row.severity)
        }, {
          header: 'Category',
          accessorKey: 'category'
        }, {
          header: 'Reported Date',
          accessorKey: 'reported'
        }, {
          header: 'Due Date',
          accessorKey: 'due'
        }, {
          header: 'Status',
          cell: row => <StatusPill status={row.status} data-id="element-1629" />
        }]} onRowClick={setSelectedIncident} data-id="element-1627" />
        </div>
      </Card>
      <Drawer isOpen={!!selectedIncident} onClose={() => setSelectedIncident(null)} title="Incident Details" size="lg" footer={<>
            <Button variant="ghost" onClick={() => setSelectedIncident(null)} data-id="element-1631">
              Close
            </Button>
            <Button variant="secondary" data-id="element-1632">Request Extension</Button>
            <Button variant="primary" data-id="element-1633">Submit CAPA</Button>
          </>} data-id="element-1630">
        {selectedIncident && <div className="space-y-6" data-id="element-1634">
            <div className="flex justify-between items-start" data-id="element-1635">
              <div data-id="element-1636">
                <h2 className="text-xl font-bold text-text-primary mb-2" data-id="element-1637">
                  {selectedIncident.title}
                </h2>
                <div className="flex gap-2 items-center" data-id="element-1638">
                  <span className="text-sm text-text-secondary" data-id="element-1639">
                    {selectedIncident.id}
                  </span>
                  {getSeverityBadge(selectedIncident.severity)}
                  <StatusPill status={selectedIncident.status} data-id="element-1640" />
                </div>
              </div>
            </div>
            <Card variant="flat" className="p-4" data-id="element-1641">
              <h3 className="text-sm font-semibold mb-2" data-id="element-1642">
                Complaint Description
              </h3>
              <p className="text-sm text-text-secondary" data-id="element-1643">
                A temperature deviation was recorded during the transit of
                shipment SHP-2026-089. The temperature logger indicated a spike
                to 8°C for 4 hours, which exceeds the acceptable threshold of
                4°C for chilled seafood.
              </p>
            </Card>
            <div data-id="element-1644">
              <h3 className="text-lg font-semibold mb-3" data-id="element-1645">
                Corrective Action Plan (CAPA)
              </h3>
              <div className="space-y-4" data-id="element-1646">
                <div data-id="element-1647">
                  <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1648">
                    Root Cause Analysis
                  </label>
                  <textarea className="w-full p-2 border border-border-default rounded-fluent text-sm" rows={3} placeholder="Enter root cause..." data-id="element-1649"></textarea>
                </div>
                <div data-id="element-1650">
                  <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1651">
                    Corrective Action
                  </label>
                  <textarea className="w-full p-2 border border-border-default rounded-fluent text-sm" rows={3} placeholder="Enter corrective action..." data-id="element-1652"></textarea>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-1653">
                  <div data-id="element-1654">
                    <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1655">
                      Target Date
                    </label>
                    <input type="date" className="w-full p-2 border border-border-default rounded-fluent text-sm" data-id="element-1656" />
                  </div>
                  <div data-id="element-1657">
                    <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-1658">
                      Responsible Person
                    </label>
                    <input type="text" className="w-full p-2 border border-border-default rounded-fluent text-sm" placeholder="Name" data-id="element-1659" />
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-1660">
              <h3 className="text-lg font-semibold mb-3" data-id="element-1661">Timeline</h3>
              <Timeline items={[{
            title: 'Incident Reported',
            description: 'Reported by FPG Quality Team',
            timestamp: selectedIncident.reported,
            status: 'completed'
          }, {
            title: 'Acknowledged',
            description: 'Acknowledged by Supplier',
            timestamp: 'Mar 12, 2026',
            status: 'completed'
          }, {
            title: 'CAPA Submission',
            description: 'Pending submission',
            timestamp: selectedIncident.due,
            status: 'current'
          }, {
            title: 'Closed',
            description: 'Pending FPG approval',
            timestamp: '',
            status: 'upcoming'
          }]} data-id="element-1662" />
            </div>
          </div>}
      </Drawer>
    </div>;
};